<template>
	<gc-dialog
		title="模组注册"
		width="490px"
		:show.sync="visible"
		@close="$emit('close-modal')"
		@cancel="$emit('close-modal')"
		@ok="handleSubmitForm"
		:okLoading="requestLoading"
	>
		<el-form :model="modelForm" :rules="rules" ref="modelForm" label-position="top" label-width="100px">
			<el-form-item label="设备通讯编号" prop="deviceNo">
				<el-input size="small" v-model="modelForm.deviceNo" placeholder="请输入"></el-input>
			</el-form-item>
			<el-form-item label="IMEI" prop="imei">
				<el-input size="small" v-model="modelForm.imei" placeholder="请输入"></el-input>
			</el-form-item>
			<el-form-item label="设备组" prop="deviceGroupId">
				<el-select v-model="modelForm.deviceGroupId" placeholder="请选择">
					<el-option
						v-for="item in deviceGroupOptions"
						:key="item.id"
						:label="item.deviceGroupName"
						:value="item.id"
						:disabled="item.status === 0"
					></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="设备类型">
				<el-input
					size="small"
					v-model="modelForm.deviceTypeName"
					disabled
					placeholder="运营商平台自动填充"
				></el-input>
			</el-form-item>
			<el-form-item label="运营商平台">
				<el-input
					size="small"
					v-model="modelForm.platformName"
					disabled
					placeholder="运营商平台自动填充"
				></el-input>
			</el-form-item>
		</el-form>
	</gc-dialog>
</template>

<script>
import { apiCreateImeiModule } from '@/apis/communicationModelManage.api'
import { ruleMaxLength, ruleRequired } from '@/utils/rules'
export default {
	props: {
		deviceGroupOptions: {
			type: Array,
			default: () => [],
		},
	},
	data() {
		return {
			visible: true,
			modelForm: {
				deviceNo: null,
				imei: null,
				deviceGroupId: null,
				deviceTypeName: null,
				platformName: null,
			},
			rules: {
				deviceNo: [ruleRequired(), ruleMaxLength(32)],
				imei: [
					ruleRequired(),
					{
						validator: (_rule, value, callback) => {
							if (value.length !== 15 || isNaN(Number(value))) {
								return callback(new Error('只能输入15位纯数字'))
							}
							callback()
						},
						trigger: 'change',
					},
				],
				deviceGroupId: [ruleRequired('请选择')],
			},
			requestLoading: false,
		}
	},
	created() {},

	methods: {
		handleSubmitForm() {
			this.$refs.modelForm.validate(async valid => {
				if (valid) {
					this.requestLoading = true
					try {
						await apiCreateImeiModule({ ...this.modelForm, manufacturerId: this.manufacturerId })
						this.$message.success('操作成功')
						this.$emit('close-modal', true)
					} finally {
						this.requestLoading = false
					}
				}
			})
		},
	},

	watch: {
		'modelForm.deviceGroupId'(newVal) {
			const t = this.deviceGroupOptions.find(m => m.id === newVal)
			this.modelForm.deviceTypeName = t?.deviceTypeName
			this.modelForm.platformName = t?.platformName
		},
	},

	computed: {
		manufacturerId() {
			return this.$store.getters.userInfo.manufacturerId
		},
	},
}
</script>
